import { IOnInit } from "angular";

export class MachineConfigurationTypeDetailGameViewComponentController
  implements IOnInit
{
  $onInit(): void {}
}
